document.addEventListener("DOMContentLoaded", () => {

  // Scroll Animate
  const items = document.querySelectorAll(".scroll-animate");

  if (items.length) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));
  }
});